import script from "./InfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoModal.vue?vue&type=script&setup=true&lang=js"

import "./InfoModal.vue?vue&type=style&index=0&id=395d2b60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-395d2b60"]])

export default __exports__